export * from './connection-timed-out.module';
export * from './connection-timed-out.page';
